import type { HTMLAttributes } from 'react';
import { motion } from 'framer-motion';
import { THICK_TILE_STYLE } from '../dashboard/tileStyles';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: 'sm' | 'md' | 'lg';
  clickable?: boolean;
  selected?: boolean;
}

const paddingStyles = {
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
};

const MotionDiv = motion.create('div');

export function Card({
  padding = 'md',
  clickable = false,
  selected = false,
  className = '',
  style,
  children,
  ...props
}: CardProps) {
  return (
    <MotionDiv
      className={`
        relative overflow-hidden rounded-lg border
        ${selected ? 'border-l-[3px] border-l-indigo-500 border-indigo-500/30' : 'border-indigo-400/15'}
        ${clickable ? 'cursor-pointer' : ''}
        ${paddingStyles[padding]} ${className}
      `}
      style={{ ...THICK_TILE_STYLE, ...style }}
      whileHover={clickable ? { y: -2 } : undefined}
      whileActive={clickable ? { y: 0 } : undefined}
      transition={{ duration: 0.25, ease: 'easeInOut' }}
      {...(props as any)}
    >
      {children}
    </MotionDiv>
  );
}
